"use client";

import type React from "react";
import { useState, useEffect } from "react";
import { Flex, Box, IconButton, useMediaQuery } from "@chakra-ui/react";
import { HamburgerIcon } from "@chakra-ui/icons";
import { useAppTheme } from "../ThemeContext.tsx";
import Sidebar from "./Sidebar.tsx";

interface LayoutProps {
  children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  const { resolvedTheme } = useAppTheme();
  const isDark = resolvedTheme === "dark";
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);
  const [isLargerThan768] = useMediaQuery("(min-width: 768px)");

  useEffect(() => {
    setIsSidebarOpen(isLargerThan768);
  }, [isLargerThan768]);

  const toggleSidebar = () => setIsSidebarOpen(!isSidebarOpen);

  return (
    <Flex minHeight="100vh" color={isDark ? "white" : "gray.800"} maxW="100%">
      <Sidebar isOpen={isSidebarOpen} onClose={() => setIsSidebarOpen(false)} />
      <Box
        flex="1"
        ml={{ base: 0, md: isSidebarOpen ? "230px" : 0 }}
        transition="margin-left 0.3s"
        bg={isDark ? "gray.900" : "gray.100"}
      >
        <Box>
          <IconButton
            aria-label="Toggle Sidebar"
            icon={<HamburgerIcon />}
            onClick={toggleSidebar}
            display={{ base: "inline-flex", md: "none" }}
          />
        </Box>
        <Box overflowY="auto">{children}</Box>
      </Box>
    </Flex>
  );
};

export default Layout;
